/*if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}*/

if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
$(document).ready(function(){
  var toggleButton = '<a href="" class="toggle-button" title="See more">See more</a>';
  var toggleButtonOff = '<a href="" class="toggle-button--off" title="See less" style="display:none;">See less</a>';

  $(".toggle-this-container").each(function(){
    if ($(this).find(".toggle-button").length === 0) {
      $(this).append(toggleButton + toggleButtonOff);
    }
  });

  $(document).on('click', '.toggle-button', function (e) {
    e.preventDefault();
    var $container = $(this).closest('.toggle-this-container');
    $container.find('.toggle-this').addClass('active');
    $(this).hide();
    $container.find('.toggle-button--off').show();
  });

  $(document).on('click', '.toggle-button--off', function (e) {
    e.preventDefault();
    var $container = $(this).closest('.toggle-this-container');
    $container.find('.toggle-this').removeClass('active');
    $(this).hide();
    $container.find('.toggle-button').show();
  });
});

